import {DevConfig} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';

export const devConfig: DevConfig = {
  modelCombinedDropdowns: true,
  tireCombinedDropdowns: true,
  usePreHeatedData: false,
};
